var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FAE5FF",
    d: "M20 39.5a3.5 3.5 0 0 1-2.498-1.03L1.529 22.498a3.54 3.54 0 0 1 0-4.996L17.502 1.53C18.166.866 19.054.5 20 .5s1.834.366 2.498 1.03l15.973 15.972a3.54 3.54 0 0 1 0 4.996L22.498 38.47A3.5 3.5 0 0 1 20 39.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CB6CE6",
    d: "M20 1c.813 0 1.575.314 2.144.883l15.972 15.972a3.037 3.037 0 0 1 0 4.289L22.144 38.117c-.569.569-1.331.883-2.144.883s-1.575-.314-2.144-.883L1.883 22.144a3.037 3.037 0 0 1 0-4.289L17.856 1.883A3 3 0 0 1 20 1m0-1a4.02 4.02 0 0 0-2.852 1.176L1.176 17.149a4.045 4.045 0 0 0 0 5.703l15.972 15.972C17.933 39.608 18.966 40 20 40s2.067-.392 2.852-1.176l15.972-15.972a4.045 4.045 0 0 0 0-5.703L22.852 1.176A4.02 4.02 0 0 0 20 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CB6CE6",
    d: "M23 25v-5h-5.933C16 20.041 16 20.852 16 21.21V27h-4v-5.79c0-3.913 3.189-5.21 5.333-5.21H23v-5l8 7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionIcon);
export default __webpack_public_path__ + "static/media/direction_icon.ad2a3625e376b641999ef413dd6505b4.svg";
export { ForwardRef as ReactComponent };